import { Measurements } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html, css } from '../../utility/lit-entity';
import { BinIssueStateMixin } from './bin-issue-state-mixin';

class BinIssueStateDimensionsForm extends BinIssueStateMixin(LitEntity) {
  constructor() {
    super();
    this.collectedFields = ['correctedDimensions'];
    this.dimension = Measurements.get('dimension');
    this.rawInputs = {};
  }

  static get styles() {
    return [...super.styles, css`
      bin-profile-svg {
        height: 25vh;
        max-height: 250px;
      }
      .flex.col.inputs {
        align-items: flex-start;
        flex-shrink: 1;
      }
    `];
  }

  render() {
    const dimensions = this._getRenderDimensions();
    return html`
      <h2>Please enter suggestions for correction to the bin measurements</h2>
      <div class="flex row">
        <div class="flex col profile">
          <bin-profile-svg
            bindimensions="${JSON.stringify(dimensions)}"
            .padding="${3}"
            nodevice
          ></bin-profile-svg>
        </div>
        <div class="flex col inputs">
          <bn-form-field
            type="number"
            title="Top Height"
            @input="${(e) => this._onBinDimensionInput(e, 'topHeight', true)}"
            .value="${this.rawInputs && this.rawInputs.topHeight}"
          >
            <span slot="suffix" class="suffix">${this.dimension.unit}</span>
          </bn-form-field>

          <bn-form-field
            type="number"
            title="Body Height"
            @input="${(e) => this._onBinDimensionInput(e, 'bodyHeight', true)}"
            .value="${this.rawInputs && this.rawInputs.bodyHeight}"
          >
            <span slot="suffix" class="suffix">${this.dimension.unit}</span>
          </bn-form-field>

          <bn-form-field
            type="number"
            title="Ring Count"
            @input="${(e) => this._onBinDimensionInput(e, 'ringCount', false)}"
            .value="${this.rawInputs && this.rawInputs.ringCount}"
          ></bn-form-field>

          <bn-form-field
            type="number"
            title="Bin Diameter"
            @input="${(e) => this._onBinDimensionInput(e, 'diameter', true)}"
            .value="${this.rawInputs && this.rawInputs.diameter}"
          >
            <span slot="suffix" class="suffix">${this.dimension.unit}</span>
          </bn-form-field>

          <bn-form-field
            type="number"
            title="Hopper Height"
            @input="${(e) => this._onBinDimensionInput(e, 'hopperHeight', true)}"
            .value="${this.rawInputs && this.rawInputs.hopperHeight}"
          >
            <span slot="suffix" class="suffix">${this.dimension.unit}</span>
          </bn-form-field>
        </div>
      </div>

      ${this.renderNext()}
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    Object.assign(this.rawInputs, this.data.correctedDimensions);

    const keys = Object.keys(this.rawInputs);
    for (const key of keys) {
      this.rawInputs[key] = key === 'ringCount' ? this.rawInputs[key] : this.dimension.convert({ dimension: this.rawInputs[key] });
    }

    this.stateHasData = this._hasData();
    this.requestUpdate();
  }

  updated() {
    this.stateHasData = this._hasData();
  }

  _hasData() {
    return this.data.correctedDimensions && Object.keys(this.data.correctedDimensions).length === 5;
  }

  _getRenderDimensions() {
    // Simplest way to perform a deep copy of an object with child objects
    const dimensions = JSON.parse(JSON.stringify(this.getProperty('dimensions')));
    const { rawInputs } = this;
    dimensions.top.height = this._orSetAndReverse(rawInputs.topHeight, dimensions.top.height);
    dimensions.body.height = this._orSetAndReverse(rawInputs.bodyHeight, dimensions.body.height);
    dimensions.hopper.height = this._orSetAndReverse(rawInputs.hopperHeight, dimensions.hopper.height);
    dimensions.ringCount = rawInputs.ringCount === undefined ? dimensions.ringCount : rawInputs.ringCount;
    dimensions.body.radius = this._orSetAndReverse(rawInputs.diameter / 2, dimensions.body.radius);
    dimensions.totalHeight = dimensions.top.height + dimensions.body.height + dimensions.hopper.height;

    return dimensions;
  }

  _orSetAndReverse(possibleValue, defaultValue) {
    if (possibleValue === undefined || isNaN(possibleValue)) {
      return defaultValue;
    }

    return this.dimension.reverse({ dimension: possibleValue });
  }

  _onBinDimensionInput(e, key) {
    if (e.target.input.value === '') {
      delete this.rawInputs[key];
      this.data.correctedDimensions && delete this.data.correctedDimensions[key];
      this.requestUpdate();
      return;
    }

    const clamp = (value, min, max) => value < min ? min : value > max ? max : value;
    let value = parseFloat(e.target.input.value);
    if (key === 'ringCount') {
      value = clamp(value, 0, 100);
    } else {
      value = clamp(value, 0, 10000);
    }

    this.rawInputs[key] = value;
    this.data.correctedDimensions = this.data.correctedDimensions || {};
    this.data.correctedDimensions[key] = key === 'ringCount' ? value : this.dimension.reverse({ dimension: value });
    this.requestUpdate();
  }
}

window.customElements.define('bin-issue-state-dimensions-form', BinIssueStateDimensionsForm);
